import { bundleActions } from '@/actions/bundleActions';
import ServiceListCardWrapper from '@/components/elements/Card/ServiceListCard/ServiceListCardWrapper';
import { LinkButton } from '@/components/elements/forms/buttons';
import { SCREEN_NAME } from '@/constants/analytics';
import { getBundleValidity, url } from '@/helpers';
import { buyBundleFlowTrackingSession } from '@/helpers/checkoutFlowTrackingSession';
import { useAppSelector } from '@/hooks';
import useMobileView from '@/hooks/useMobileView';
import { _s } from '@/locale';
import { Place, PlaceBundle } from '@/types/state/shared';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import BundleReadMoreModal from './BundleReadMoreModal';

type PlaceBundleWithHighlight = PlaceBundle & { highlightedName?: React.ReactNode };

export type PlaceBundleService = {
  mpId: number;
  name: string;
  quantity: number;
};

type BundleProps = {
  place: Place;
  bundle: PlaceBundleWithHighlight;
};

const BundleListCardWrapper = ({ bundle, place }: BundleProps) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const user = useAppSelector((state) => state.users)?.user;
  const [showMoreInfo, setShowMoreInfo] = useState(false);
  const { isMobileView } = useMobileView();

  useEffect(() => {
    const selectedBundleId = parseInt(url.returnGetParameter('sb'));
    if (bundle.id === selectedBundleId) {
      setShowMoreInfo(true);
    }
    // eslint-disable-next-line
  }, []);

  const handleOnCloseMoreInfo = () => {
    setShowMoreInfo(false);
    history.replace({ search: url.changeGetParameter('sb') });
  };

  const handleOnOpenMoreInfo = () => {
    setShowMoreInfo(true);
    history.replace({ search: url.changeGetParameter('sb', bundle.id) });
  };

  const handleBuyClick = () => {
    dispatch(bundleActions.pickBundleToCheckout({ bundle, place }));
    buyBundleFlowTrackingSession.initiate(place, user, SCREEN_NAME.COMPANY_DETAILS, { bundle_template_id: bundle.id });
  };

  const handleModalBuyClick = () => {
    handleBuyClick();
    history.push('/bundles/checkout');
  };

  return (
    <li>
      <ServiceListCardWrapper
        key={bundle.id}
        id={bundle.id}
        bundle={{ quantity: bundle.service.quantity, validity: getBundleValidity(bundle.validMonths) }}
        price={{ value: [bundle.price], type: 'standard' }}
        name={bundle.name}
        highlightedName={bundle.highlightedName}
        duration={bundle.durationLabel}
        discount={bundle.finalPrice ? { amounts: [bundle.price - bundle.finalPrice] } : undefined}
        onRowClick={handleOnOpenMoreInfo}
        showInfoCta
        alignPriceColumn
        rightSlot={
          <LinkButton
            size={isMobileView ? 'md' : 'sm'}
            variant="primary"
            to="/bundles/checkout"
            onClick={(e) => {
              e.stopPropagation();
              handleBuyClick();
            }}>
            {_s('buy')}
          </LinkButton>
        }
      />
      {showMoreInfo ? (
        <BundleReadMoreModal
          bundle={bundle}
          place={place}
          onBuyClick={handleModalBuyClick}
          onClose={handleOnCloseMoreInfo}
        />
      ) : null}
    </li>
  );
};

export default BundleListCardWrapper;
